import { useEffect } from "react";
import { CommonType, ParsedRowType } from "../../../types";
import { parseToConvert } from "../../../services/rawDataService";

export const usePayloadConversion = (
  hexData: string,
  selectedParseType: CommonType | null,
  selectedConvertType: CommonType | null,
  setRawData: (data: string) => void,
  setParsed: React.Dispatch<React.SetStateAction<ParsedRowType[]>>,
  rawData: string,
  onError?: (message: string) => void
) => {
  const convertParseData = async () => {
    try {
      if (selectedParseType?.id != undefined && selectedConvertType?.id != undefined) {
        const response = await parseToConvert({
          payload: hexData,
          parseType: selectedParseType.id,
          convertType: selectedConvertType.id,
        });

        if (response.data.success) {
          const newRawData: string = response.data?.data ?? "";
          if (!newRawData) {
            setRawData("");
            return;
          }

          setRawData(newRawData);
          setParsed(prev =>
            prev.map(p => {
              const startIndex = Number(p.start);
              const endIndex = Number(p.end);

              if (
                !Number.isInteger(startIndex) ||
                !Number.isInteger(endIndex) ||
                startIndex <= 0 ||
                endIndex <= 0 ||
                startIndex > endIndex
              ) return p;

              if (endIndex > newRawData.length) return p;

              return {
                ...p,
                textValue: startIndex && endIndex
                  ? newRawData.substring(startIndex - 1, endIndex)
                  : rawData ?? ""
              };
            })
          );
        } else {
          onError?.(response.data.message ?? "Convert hatası!");
          setRawData("");
          setParsed(prev => prev.map(p => ({ ...p, textValue: "" })));
        }
      }
    } catch (error) {
      onError?.(error instanceof Error ? error.message : "Convert hatası!");
    }
  };

  useEffect(() => {
    convertParseData();
  }, [selectedConvertType, selectedParseType]);

  return {
    convertParseData,
  };
};
